import service from "../util/http";

// 车辆升级单 - 列表
export const vehicleUpgradeOrderListApi = data => {
  return service({
    url: "/manage/vehicle/upgrade/order/list",
    method: "post",
    data
  });
};

// 车辆升级单 - 保存（草稿）
export const vehicleUpgradeOrderSaveApi = data => {
  return service({
    url: "/manage/vehicle/upgrade/order/save",
    method: "post",
    data
  });
};

// 车辆升级单 - 提交（草稿 -> 已提交）
export const vehicleUpgradeOrderSubmitApi = data => {
  return service({
    url: "/manage/vehicle/upgrade/order/submit",
    method: "post",
    data
  });
};

// 车辆升级单 - 删除（仅草稿态、仅创建人）
export const vehicleUpgradeOrderDeleteApi = data => {
  return service({
    url: "/manage/vehicle/upgrade/order/delete",
    method: "post",
    data
  });
};

// 车辆升级单 - 关联质量反馈单 下拉选项（按反馈单号模糊查询，未删除，最多 50 条）
export const vehicleUpgradeQualityFeedbackOptionsApi = data => {
  return service({
    url: "/manage/vehicle/upgrade/order/qualityFeedbackOptions",
    method: "post",
    data
  });
};

// 车辆升级单 - 详情（编辑回填）
export const vehicleUpgradeOrderDetailApi = data => {
  return service({
    url: "/manage/vehicle/upgrade/order/detail",
    method: "post",
    data
  });
};

export const vehicleUpgradeQualityCountryListApi = data => {
  return service({
    url: "/manage/vehicle/upgrade/order/qualityCountryList",
    method: "post",
    data
  });
};

// 车辆升级单 - VIN 17 位 EPC 信息查询（回填品牌/车型/订单号/国家/生产日期）
export const vehicleUpgradeVinLookupApi = data => {
  return service({
    url: "/manage/vehicle/upgrade/order/vinLookup",
    method: "post",
    data
  });
};

// 车辆升级单 - 按订单号批量查询 VIN 列表（EPC 接口）
export const vehicleUpgradeVinAddByOrderApi = data => {
  return service({
    url: "/manage/vehicle/upgrade/order/vinAddByOrder",
    method: "post",
    data
  });
};

// 车辆升级单 - 下载 VIN 批量导入模板（一列 VIN）
export const vehicleUpgradeDownloadVinImportTemplateApi = () => {
  return service({
    url: "/manage/vehicle/upgrade/order/downloadVinImportTemplate",
    method: "get",
    responseType: "blob"
  });
};

// 车辆升级单 - 上传 VIN 表格并查询 EPC 信息
export const vehicleUpgradeVinImportApi = data => {
  return service({
    url: "/manage/vehicle/upgrade/order/vinImport",
    method: "post",
    headers: { "Content-Type": "multipart/form-data" },
    data
  });
};

// 车辆升级单 - 故障件 EPC 模糊查价（按国家定位客户后调 EPC）
export const vehicleUpgradePartLookupApi = data => {
  return service({
    url: "/manage/vehicle/upgrade/order/partLookup",
    method: "post",
    data
  });
};

// 车辆升级单 - 分发弹窗 经销商下拉（按国家筛选，受服务经理权限范围约束）
export const vehicleUpgradeCustomerListApi = data => {
  return service({
    url: "/manage/vehicle/upgrade/order/customerList",
    method: "post",
    data
  });
};

// 车辆升级单 - 分发（VIN 维度，限制单次分发到同一经销商）
export const vehicleUpgradeDistributeApi = data => {
  return service({
    url: "/manage/vehicle/upgrade/order/distribute",
    method: "post",
    data
  });
};

// 车辆升级单 - 处理情况（按 VIN 分页查看前台完成状态与附件）
export const vehicleUpgradeDistributeStatusApi = data => {
  return service({
    url: "/manage/vehicle/upgrade/order/distributeStatus",
    method: "post",
    data
  });
};

// 车辆升级单 - 延期（仅 status=1 可延期，新结束日期需晚于原结束日期）
export const vehicleUpgradeDelayApi = data => {
  return service({
    url: "/manage/vehicle/upgrade/order/delay",
    method: "post",
    data
  });
};

// 车辆升级单 - 按国家获取预设管理费费率和工时单价
export const vehicleUpgradeGetPresetApi = data => {
  return service({
    url: "/manage/vehicle/upgrade/order/getPreset",
    method: "post",
    data
  });
};

// 车辆升级单索赔 - 列表
export const vehicleUpgradeOrderClaimListApi = data => {
  return service({
    url: "/manage/vehicle/upgrade/order/claim/list",
    method: "post",
    data
  });
};

// 车辆升级单索赔 - 详情
export const vehicleUpgradeOrderClaimDetailApi = data => {
  return service({
    url: "/manage/vehicle/upgrade/order/claim/detail",
    method: "post",
    data
  });
};

// 车辆升级单索赔 - 通过
export const vehicleUpgradeOrderApproveApi = data => {
  return service({
    url: "/manage/vehicle/upgrade/order/claim/approve",
    method: "post",
    data
  });
};

// 车辆升级单索赔 - 驳回
export const vehicleUpgradeOrderRejectApi = data => {
  return service({
    url: "/manage/vehicle/upgrade/order/claim/reject",
    method: "post",
    data
  });
};

// 车辆升级单索赔 - 结算
export const vehicleUpgradeOrderSettleApi = data => {
  return service({
    url: "/manage/vehicle/upgrade/order/claim/settle",
    method: "post",
    data
  });
};

// 车辆升级单索赔 - 保存（审核时编辑保存）
export const vehicleUpgradeOrderReviewSaveApi = data => {
  return service({
    url: "/manage/vehicle/upgrade/order/save",
    method: "post",
    data
  });
};

// 车辆升级单索赔 - 通过
// export const vehicleUpgradeOrderApproveApi = data => {
//   return service({
//     url: "/manage/vehicle/upgrade/order/approve",
//     method: "post",
//     data
//   });
// };

// 车辆升级单索赔 - 驳回
// export const vehicleUpgradeOrderRejectApi = data => {
//   return service({
//     url: "/manage/vehicle/upgrade/order/reject",
//     method: "post",
//     data
//   });
// };

// 车辆升级单索赔 - 结算
// export const vehicleUpgradeOrderSettleApi = data => {
//   return service({
//     url: "/manage/vehicle/upgrade/order/settle",
//     method: "post",
//     data
//   });
// };

// 车辆升级单索赔 - 保存（审核时编辑保存）
// export const vehicleUpgradeOrderReviewSaveApi = data => {
//   return service({
//     url: "/manage/vehicle/upgrade/order/save",
//     method: "post",
//     data
//   });
// };
